import fb from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import ListHelpers from '../helpers/ListHelpers'
import Utilities from '../helpers/Utilities'
import Vue from 'vue'

var db = fb.database()

const state = {
    transaction: {},
    transactions: [],
    transactionTemplates: [],
    transactionComments: [],
    allCommentsMode: false,
    masters: {},
}

// getters
const getters = {
    transaction: state => {
        if(!state.transaction.key) {
            let transactionString = localStorage.getItem('transaction')
            if(transactionString) {
                state.transaction = JSON.parse(transactionString) || {}
                //Utilities.log('transaction-store > getters > transaction - Loading from local storage', state.transaction)
            }
        }

        return state.transaction
    },
    transactionTemplates: state => {
        return state.transactionTemplates
    },
    allCommentsMode: state => {
        return state.allCommentsMode
    },
    transactionRef: state => {
        return DataHelpers.getTenantRef().child('transaction').child(state.transaction.key)
    },
    transactionComments: state => {
        return state.transactionComments
    },
    masters: state => {
        return state.masters
    },
    
}

// actions
const actions = {


    loadTransaction(context, transactionKey) {
        return new Promise( (resolve, reject) => {
            
            if(context.getters.transaction.key == transactionKey) {
                //No change to previous key...
                resolve(context.getters.transaction)
            } else {
                //Changing...
                context.commit('setTransaction', {key: transactionKey, loading: true})
                context.commit('setTransactionComments', [])
                context.commit('setElements', [])
            }

            let ref = db.ref(`tenants/${context.getters.tenantKey}/transactions/${transactionKey}/details`)
            ref.once('value', function(snapItem) {
                
                let item = snapItem.val()
                if(!item) {
                    console.log('No transaction found at ' + ref.toString())
                    reject('No transaction found')
                    return
                }

                item.key = transactionKey
                context.commit('setTransaction', item)
                Utilities.log('transaction-store > loadTransaction (from DB)')
                resolve(item)
            })
        })
    },

    loadTransactionTemplates(context) {
        return new Promise(function(resolve, reject) {
    
            if(context.getters.transactionTemplates.length  > 0) {
                resolve('cached')
                return
            }

            let ref = db.ref(`tenants/${context.getters.tenantKey}/transactionTemplates`)
            ref.on('value', function(snap) {
                console.log('store > loadTransactionTemplates (first load)')
                let transactionTemplates = FirebaseHelpers.snapshotToArray(snap)
                context.commit('setTransactionTemplates', transactionTemplates)
                resolve('loaded')
            })  
        })
    },

    loadTransactionComments(context) {
        return new Promise(function(resolve, reject) {
    
            if(context.getters.transactionComments.length  > 0) {
                resolve('cached')
                return
            }

            let ref = db.ref(`tenants/${context.getters.tenantKey}/transactions/${context.getters.transaction.key}/comments`)
            
            ref.once('value', function(snap) {
                console.log('store > loadTransactionComments (first load)')
                let transactionComments = FirebaseHelpers.snapshotToArray(snap, true)
                context.commit('setTransactionComments', transactionComments)
                resolve('loaded')
            })  
        })
    },

    loadMaster(context) {
        return new Promise( (resolve, reject) => {

            let masterKey = context.getters.transaction.masterKey
            if(!masterKey) {
                Utilities.log('loadMaster > No masterKey')
                resolve('No Master Key')
                return
            }

            //No change to previous key...
            if(context.getters.masters[masterKey]) {
                Utilities.log('loadMaster > Master key already loaded')                
                resolve('Cached')
                return
            }

            //Changing...
            //Note: trying master with reactive snapshot...
            let ref = DataHelpers.getTenantRef().child('transactions').child(masterKey).child('elements')
            ref.on('value', function(snap) {
                let masterElements = FirebaseHelpers.snapshotToArray(snap)
                context.commit('setMaster', {key: masterKey, elements: masterElements})
                Utilities.log('transaction-store > loadMaster - first load')
                resolve('Loaded')
            })
        })
    },

    saveTransaction(context, obj) {
        Utilities.log('TransactionsStore > saveTransaction', obj)
        let newObj = Object.assign({}, obj) 
        context.commit('setTransaction', newObj)
        setTimeout( () => {
            let ref = DataHelpers.getTransactionRef().child('details')
            FirebaseHelpers.saveToFirebase(newObj, ref)          
        }, 1000)
  
    },

    saveTransactionComment(context, obj) {
        Utilities.log('TransactionsStore > saveTransactionComment', obj)
        let newObj = ListHelpers.prepareSave(obj) 
        context.commit('saveTransactionComment', newObj)
        let ref = DataHelpers.getTransactionRef().child('comments')
        FirebaseHelpers.saveToFirebase(newObj, ref)
    },

    deleteTransactionComment(context, obj) {
        Utilities.log('TransactionsStore > deleteTransactionComment', obj)
        context.commit('deleteTransactionComment', obj)
        let ref = DataHelpers.getTransactionRef().child('comments')
        FirebaseHelpers.deleteFromFirebase(obj, ref)
    }
}

// mutations
const mutations = {

    groups (state, groups) {
        state.groups = groups           
    }, 

    setTransaction (state, newVal) {
    
        state.transaction = newVal 
        if(!newVal.loading)
            localStorage.setItem('transaction', JSON.stringify(newVal))          
    },                      
    setTransactionTemplates (state, newVal) {
        state.transactionTemplates = newVal           
    },                      
    setTransactionComments (state, newVal) {
        state.transactionComments = newVal           
    },                      
    saveTransactionComment (state, newVal) {
        ListHelpers.save(newVal, state.transactionComments, 0)          
    },                      
    deleteTransactionComment (state, comment) {
        ListHelpers.delete(comment, state.transactionComments)          
    },
    
    setMaster (state, payload) {
        Vue.set(state.masters, payload.key, payload.elements)          
    }, 
    allCommentsMode (state, payload) {
        state.allCommentsMode = payload          
    }, 
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/TransactionsStore.js